import { useQuery } from '@tanstack/react-query';

import { simulationsEndpoints } from '@/api/endpoints';
import { callPost } from '@/api/fetcher';
import type { SimulationDraft } from '@/shared/types/simulation-draft';

interface UseSimulationDraftOptions {
  brainId: string | null;
  transcript: string;
  startingContext: string;
}

/** A POST behind `useQuery` because the route persists nothing; the transcript is the cache key. */
export const useSimulationDraft = ({
  brainId,
  transcript,
  startingContext,
}: UseSimulationDraftOptions) => {
  const { data, isLoading, isError } = useQuery<SimulationDraft>({
    queryKey: ['simulationDraft', brainId, transcript],
    queryFn: () =>
      callPost(simulationsEndpoints.draft(brainId!), {
        transcript,
        starting_context: startingContext || undefined,
      }),
    enabled: Boolean(brainId) && Boolean(transcript),
    staleTime: Infinity,
    retry: false,
  });

  return { draft: data, isDrafting: isLoading, hasFailed: isError };
};
